<template>
    <div class="page-content">
                  <nav class="page-breadcrumb" id="breadcrumb">
                    <ol class="breadcrumb">
                      <li class="breadcrumb-item">{{breadcrumbA}}</li>
                      <li class="breadcrumb-item active" aria-current="page">{{breadcrumbB}}</li>
                    </ol>
                  </nav>

                  <div class="row">
                    <div class="col-md-12 grid-margin stretch-card">
                      <div class="card">
                        <div class="card-body">
                          <h6 class="card-title"><i class="link-icon" data-feather="box"></i> {{breadcrumbB}}</h6>
                          <p class="card-description">
                           {{descripcion}}
                            </p>

                        </div>  
                      </div>
                    </div>
                  </div>    

                 <lista-carga v-if="triggers.load"></lista-carga>

                  <div class="row" v-else>
                    <div class="col-md-12 grid-margin stretch-card">
                      <div class="card">
                        <div class="card-body">



                         <div class="row mb-3">
                                <div class="col">
                                    <label class="mr-sm-2">Numero de liquidación</label>
                                    <select id='liqui'></select>
                                </div>
                                
                                <div class="col">
                                    <label class="mr-sm-2 w-100" for="">&nbsp;</label>
                                    <button  class="btn btn-md btn-success w-100" @click="obtenerPersonal()">Consultar</button>
                                </div>
                            </div>

                          <div class="table-responsive">
                            <table id="empresas" class="table">
                              <thead>
                                <tr>
                                  
                                  <th>Id</th>
                                  <th>Nombre y Apellido</th>
                                
                                  <th>Importe Neto</th>
                                  <th>Operación</th>
                                  <th>Categoría</th>
                                  
                                  
                                  <th>FIRMADO</th>
                                  <th>RECIBO</th>
                                </tr>
                              </thead>
                              <tbody>
                                <tr v-for="personal in personal" v-bind:key="personal">
                                  
                                    <td>{{personal.legajo}}</td>
                                    <td>{{personal.nombre}}</td>
                                    
                                    <td>{{personal.neto}}</td>
                                    <td>{{personal.operacion}}</td>
                                    <td>{{personal.categoria}}</td>
                                   
                                    
                                     <td>{{personal.firmado}}</td>
                                    <td><a target="_blank" :href="personal.recibo">VER</a></td>
                                   
                                </tr>
                              </tbody>
                            </table>
                             <div class="alert alert-danger"  role="alert" id="alerta">
                                  Escribe un número de liquidación y consulta.
                                </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>


                <modal-administrar
                    v-if="modalAdministrar.open" 
                    :empresa="modalOperacionId"
                    :legajoEmpleado="modalAdministrar.legajo"
                    :nombreEmpleado="modalAdministrar.nombre"
                    :apellidoEmpleado="modalAdministrar.apellido"
                    :operacion="modalAdministrar.operacion"
                    :idDistribucion="modalAdministrar.idDistribucion"
                    @cerrar-modal-asignar="refrescarPersonal($event)"
                >
                </modal-administrar>

                <modal-legales
                    v-if="modalLegales.open" 
                    :dniEmpleado="modalLegales.dni"
                    :nombreEmpleado="modalLegales.nombre"
                    :apellidoEmpleado="modalLegales.apellido"
                    :legajoEmpleado="modalLegales.legajo"
                    @cerrar-modal-legales="refrescarPersonal($event)"
                ></modal-legales>

            </div>
     

</template>

<script>

import axios from 'axios';
import $ from 'jquery';
require('datatables.net');
require('datatables.net-buttons/js/buttons.colVis.js')();
require('datatables.net-buttons/js/buttons.html5.js')();
require('datatables.net-buttons/js/buttons.flash.js')();
require('datatables.net-buttons/js/buttons.print.js')();
import ListaCarga from '../ListaCarga.vue';
import ModalAdministrar from './ModalAdministrar.vue';
import ModalLegales from './ModalLegales';
const userPermission = JSON.parse(sessionStorage.getItem('userPermisos'));
//$("title").html("Liquidacion");
export default {
    name: 'Liquidacion',
    components: {ListaCarga, ModalAdministrar, ModalLegales},
    data() {
        return {
            breadcrumbA: 'Inicio',
            breadcrumbB: 'Liquidacion Food Service Catering',
            descripcion: 'En este modulo usted podra visualizar los salarios depositados en el banco del personal',
            triggers: {load:true},
            personal: [],
            reciboStatusCache: {},
            reciboStatusPromiseCache: {},
            modalAdministrar: {
                open: false,
                legajo: null,
                nombre: null,
                apellido: null,
                operacion: null,
                idDistribucion: null,
            },
            modalLegales: {
                open: false,
                dni: null,
                nombre: null,
                apellido: null,
            },
        }
    },
    methods: {
        isEditor(modulo){
      
          if (userPermission.find( record => record.ModulosAccess === modulo)) {
            var status =  userPermission.find( record => record.ModulosAccess === modulo).Editor;
            // console.log(modulo+' : '+status)
            return status;
          }else{
            console.log(modulo+' : '+false)
            return false;
          }
        },
        abrirModalAdministrar(legajo,nombre,apellido,operacion,idDistibucion){
            this.modalAdministrar.legajo = legajo;
            this.modalAdministrar.nombre = nombre;
            this.modalAdministrar.apellido = apellido;
            this.modalAdministrar.operacion = (operacion == '-') ? undefined : operacion;
            this.modalAdministrar.idDistribucion = idDistibucion;
            this.modalAdministrar.open = true;
        },
        abrirModalLegales(dni,nombre,apellido,legajo){
            this.modalLegales.dni = dni;
            this.modalLegales.nombre = nombre;
            this.modalLegales.apellido = apellido;
            this.modalLegales.legajo = legajo;
            this.modalLegales.open = true;
        },
        obtenerPeriodoLiquidacion(){
            const opcion = $("#liqui option:selected");
            const texto = String(opcion.text() || '')
                .normalize('NFD')
                .replace(/[\u0300-\u036f]/g, '')
                .toLowerCase();
            const meses = {
                enero: 1, febrero: 2, marzo: 3, abril: 4,
                mayo: 5, junio: 6, julio: 7, agosto: 8,
                septiembre: 9, setiembre: 9, octubre: 10,
                noviembre: 11, diciembre: 12,
            };

            let mesPago;
            let mesCalendario;

            if (/s\.?\s*a\.?\s*c\.?.*1.*semestre/.test(texto)) {
                mesPago = 13;
                mesCalendario = 6;
            } else if (/s\.?\s*a\.?\s*c\.?.*2.*semestre/.test(texto)) {
                mesPago = 14;
                mesCalendario = 12;
            } else {
                const nombreMes = Object.keys(meses).find(nombre => texto.indexOf(nombre) !== -1);
                mesPago = nombreMes ? meses[nombreMes] : parseInt(opcion.data("mes"), 10);
                mesCalendario = mesPago;
            }

            const anioTexto = texto.match(/\b(19|20)\d{2}\b/);
            const anio = anioTexto ? parseInt(anioTexto[0], 10) : parseInt(opcion.data("anio"), 10);

            if (!mesPago || !mesCalendario || !anio) {
                throw new Error('No se pudo determinar el período de la liquidación seleccionada.');
            }

            const fechaPago = new Date(Date.UTC(anio, mesCalendario, 6));
            const pad = numero => String(numero).padStart(2, '0');

            return {
                mesPago: mesPago,
                anio: anio,
                banco: 'BBVA',
                lugarPago: 'Buenos Aires',
                fecha: fechaPago.getUTCFullYear() + '-' +
                    pad(fechaPago.getUTCMonth() + 1) + '-' +
                    pad(fechaPago.getUTCDate()),
            };
        },
        construirUrlConsultaRecibos(liquidacion, periodo){
            const parametros = [
                ['type', 'recibos'],
                ['empresa', 'CAT'],
                ['liquidacion', liquidacion],
                ['legajo', 0],
                ['mes_pago', periodo.mesPago],
                ['anio_pago', periodo.anio],
                ['lugar_pago', periodo.lugarPago],
                ['mes', periodo.mesPago],
                ['banco', periodo.banco],
                ['fecha', periodo.fecha],
                ['access_token', '1234567'],
            ];

            return 'https://auth.foodservice.com.ar/?' + parametros
                .map(parametro => encodeURIComponent(parametro[0]) + '=' + encodeURIComponent(parametro[1]))
                .join('&');
        },
        construirUrlRecibo(liquidacion, dni, periodo){
            const parametros = [
                ['r', 'CAT'],
                ['l', liquidacion],
                ['d', dni],
                ['mes', periodo.mesPago],
                ['anio', periodo.anio],
                ['banco', periodo.banco],
                ['fecha', periodo.fecha],
            ];

            return 'https://servicio.foodservice.com.ar/mifoodtest/getrcb/recibo.php?' + parametros
                .map(parametro => encodeURIComponent(parametro[0]) + '=' + encodeURIComponent(parametro[1]))
                .join('&');
        },
        calcularNetoRecibo(conceptos){
            let haberes = 0;
            let descuentos = 0;
            let ajustes = 0;

            Object.keys(conceptos || {}).forEach(codigo => {
                const concepto = conceptos[codigo] || {};
                const importe = Number(concepto.ndet_impcal) || 0;
                const tipo = Number(concepto.con_tipo);

                if (tipo === 0) haberes += importe;
                if (tipo === 2) descuentos += importe;
                if (tipo === 5) ajustes += importe;
            });

            return (haberes + ajustes) - descuentos;
        },
        async obtenerStatusRecibo(liquidacion, dni){
            const documento = String(dni == null ? '' : dni).replace(/\D/g, '');
            const cacheKey = 'CAT|' + liquidacion + '|' + documento;

            if (Object.prototype.hasOwnProperty.call(this.reciboStatusCache, cacheKey)) {
                return this.reciboStatusCache[cacheKey];
            }
            if (Object.prototype.hasOwnProperty.call(this.reciboStatusPromiseCache, cacheKey)) {
                return this.reciboStatusPromiseCache[cacheKey];
            }
            if (!documento) return null;

            const url = 'https://aplicativos.firebaseio.com/recibos/CAT/' +
                encodeURIComponent(liquidacion) + '/' +
                encodeURIComponent(documento) + '/status.json';

            const consulta = axios.get(url)
                .then(respuesta => {
                    const status = respuesta.data === null ? null : Number(respuesta.data);
                    this.reciboStatusCache[cacheKey] = status;
                    return status;
                })
                .catch(error => {
                    console.error('No se pudo consultar el estado del recibo', liquidacion, documento, error);
                    return null;
                });

            this.reciboStatusPromiseCache[cacheKey] = consulta;
            const status = await consulta;
            delete this.reciboStatusPromiseCache[cacheKey];
            return status;
        },
        textoStatusRecibo(status){
            if (Number(status) === 1) return 'Conforme';
            if (Number(status) === 2) return 'No conforme';
            return '-';
        },
        async obtenerPersonal(){
            const liquidacion = String($("#liqui").val() || '');

            if (!liquidacion) {
                $("#alerta").text('Seleccioná un número de liquidación.').show();
                return;
            }

            let periodo;
            try {
                periodo = this.obtenerPeriodoLiquidacion();
            } catch (error) {
                $("#alerta").text(error.message).show();
                return;
            }

            if ($.fn.DataTable.isDataTable('#empresas')) {
                $('#empresas').DataTable().destroy();
            }
            this.triggers.load = true;

            try {
                const respuestas = await axios.all([
                    axios.get(this.construirUrlConsultaRecibos(liquidacion, periodo)),
                    axios.get('https://aplicativos.firebaseio.com/categorias.json?print=pretty'),
                    axios.get('https://aplicativos.firebaseio.com/distribucion.json?print=pretty'),
                    axios.get('https://consumos.foodservice.com.ar/api/empresas'),
                    axios.get('https://auth.foodservice.com.ar/?type=personal&access_token=1234567'),
                ]);

                const recibos = respuestas[0].data || {};
                const categorias = respuestas[1].data || {};
                const distribucion = respuestas[2].data || {};
                const operaciones = respuestas[3].data || [];
                const nomina = respuestas[4].data || {};

                const categoriaPorCodigo = {};
                Object.keys(categorias).forEach(clave => {
                    const categoria = categorias[clave];
                    if (categoria && categoria.codigo != null) {
                        categoriaPorCodigo[String(categoria.codigo)] = categoria.nombre;
                    }
                });

                const categoriaNominaPorDni = {};
                Object.keys(nomina).forEach(clave => {
                    const empleado = nomina[clave];
                    if (empleado && empleado.leg_numdoc != null) {
                        categoriaNominaPorDni[String(empleado.leg_numdoc)] = empleado.cat_codigo;
                    }
                });

                const operacionPorId = {};
                Object.keys(operaciones).forEach(clave => {
                    const operacion = operaciones[clave];
                    if (operacion && operacion.id != null) {
                        operacionPorId[String(parseInt(operacion.id, 10))] = operacion.name;
                    }
                });

                const legajosPermitidos = {};
                const distribucionPorLegajo = {};
                Object.keys(distribucion).forEach(idDistribucion => {
                    const bloque = distribucion[idDistribucion];
                    const registros = bloque && bloque.legajo != null
                        ? [bloque]
                        : Object.keys(bloque || {}).map(clave => bloque[clave]);
                    const idNormalizado = String(parseInt(idDistribucion, 10));

                    registros.forEach(registro => {
                        if (!registro || registro.legajo == null) return;
                        const legajo = String(parseInt(registro.legajo, 10));
                        distribucionPorLegajo[legajo] = idNormalizado;

                        if (idNormalizado === '900101' ||idNormalizado === '033503188' ||idNormalizado === '100111' ||idNormalizado === '8788998723' ||idNormalizado === '999997' ||
                            Object.prototype.hasOwnProperty.call(operacionPorId, idNormalizado)) {
                            legajosPermitidos[legajo] = true;
                        }
                    });
                });

                const lista = [];
                Object.keys(recibos).forEach(legajoRespuesta => {
                    const recibo = recibos[legajoRespuesta] || {};
                    const encabezado = recibo.encabezado || {};
                    const legajo = String(parseInt(legajoRespuesta, 10));

                    if (!legajosPermitidos[legajo]) return;

                    const dni = String(encabezado.numdoc == null ? '' : encabezado.numdoc);
                    const codigoCategoria = categoriaNominaPorDni[dni];
                    const idDistribucion = distribucionPorLegajo[legajo];
                    const nombre = ((encabezado.apellido || '') + ' ' + (encabezado.nombre || '')).trim();
                    const neto = this.calcularNetoRecibo(recibo.liquidacion);

                    lista.push({
                        legajo: legajoRespuesta,
                        nombre: nombre || '-',
                        dni: dni,
                        recibo: this.construirUrlRecibo(liquidacion, dni, periodo),
                        cbu: encabezado.leg_ctaban || '-',
                        neto: neto.toLocaleString('es-AR', {
                            minimumFractionDigits: 2,
                            maximumFractionDigits: 2,
                        }),
                        anio: periodo.anio,
                        mes: periodo.mesPago,
                        dia: '06',
                        cuil: encabezado.leg_cuil || '-',
                        firmado: '-',
                        operacion: operacionPorId[idDistribucion] || 'Sin distribuir',
                        categoria: encabezado.cat_descrip ||
                            categoriaPorCodigo[String(codigoCategoria)] ||
                            '-',
                    });
                });

                const estados = await Promise.all(
                    lista.map(item => this.obtenerStatusRecibo(liquidacion, item.dni))
                );
                lista.forEach((item, index) => {
                    item.firmado = this.textoStatusRecibo(estados[index]);
                });

                this.personal = lista;
                this.triggers.load = false;
                await this.$nextTick();
                $("#alerta").hide();

                $('#empresas').DataTable({
                    language: {
                        decimal: ',',
                        thousands: '.',
                        info: 'Mostrando registros del _START_ al _END_ de un total de _TOTAL_ registros',
                        infoEmpty: 'Mostrando registros del 0 al 0 de un total de 0 registros',
                        infoFiltered: '(filtrado de un total de _MAX_ registros)',
                        loadingRecords: 'Cargando...',
                        lengthMenu: 'Mostrar _MENU_ registros',
                        processing: 'Procesando...',
                        search: 'Buscar:',
                        zeroRecords: 'No se encontraron resultados',
                        emptyTable: 'Ningún dato disponible en esta tabla',
                        paginate: {
                            first: 'Primero', last: 'Último',
                            next: 'Siguiente', previous: 'Anterior',
                        },
                    },
                    search: {regex:true},
                    dom: 'Bfrtip',
                    responsive: false,
                    buttons: ['copy', 'excel', 'csv', 'pdf'],
                });
            } catch (error) {
                console.error('No se pudo consultar la liquidación', error);
                this.personal = [];
                this.triggers.load = false;
                await this.$nextTick();
                $("#alerta").text('No se pudo consultar la liquidación. Intenta nuevamente.').show();
            }
        },
        refrescarPersonal(seReasigno){
            this.modalAdministrar.open = false;
            this.modalLegales.open = false;
            if (seReasigno) {
                $('#empresas').dataTable().fnDestroy();
                this.obtenerPersonal();
            }

            // this.$nextTick(()=>{
            // })
        },
    },
   async mounted() {
        //this.obtenerPersonal();
         this.triggers.load = false;


            const liquidacion = axios.get('https://aplicativos.firebaseio.com/liquidacion_recibos/CAT.json');
        
            

            await axios.all([liquidacion]).then(
            axios.spread((liquidaciones) => {
               



                    $.each(liquidaciones.data, function(clave, value) {
                        console.log(value)
                       $("#liqui").prepend("<option data-anio='"+value.anio+"' data-mes='"+value.mes+"' value='"+value.liquidacion+"'>"+value.option+"</option>")
                    })

})).then(() => {});



    },
};
</script>

<style scoped>
.fila-no-distribuido {
    /* color: red; */
    /* text-shadow: rgba(255, 0, 0, 0.603) 0px 0px 1px; */
    background: radial-gradient(#ff00001a, transparent 91%);
}
</style>